/** Shared chip shell — label: value pill the param popovers anchor to. */
import { forwardRef, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/lib/utils';

type Props = {
  icon?: ReactNode;
  label: string;
  value: string;
  testId: string;
  /** Overrides the default `max-w-64` — e.g. a chip whose value is bounded
   * (a date range) can raise/drop the cap instead of truncating it. */
  className?: string;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const ParamChipButton = forwardRef<HTMLButtonElement, Props>(
  ({ icon, label, value, testId, className, ...rest }, ref) => (
    <button
      ref={ref}
      type="button"
      data-testid={testId}
      title={`${label}: ${value}`}
      className={cn(
        'inline-flex h-6 max-w-64 items-center gap-1.5 rounded-full border border-border bg-secondary/40 px-2.5 text-xs transition-colors hover:bg-secondary focus-visible:ring-1 focus-visible:ring-ring focus-visible:outline-none',
        className,
      )}
      {...rest}
    >
      {icon}
      <span className="text-muted-foreground">{label}:</span>
      <span className="truncate font-medium">{value}</span>
      <ChevronDown className="h-3 w-3 shrink-0 text-muted-foreground" />
    </button>
  ),
);
ParamChipButton.displayName = 'ParamChipButton';
